import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import { lang } from "../../assets/languages/en.language";
import { formConfig } from "../../configs/form.config";
import { FormLabel, StyledInput, StyledInputWrapper } from "../../styles/Form";
import { Gap } from "../../styles/Utils";

interface EmailInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  validate?: (value: string) => boolean | string;
}

export default function PasswordInput<T extends FieldValues>({ register, name, validate }: EmailInputProps<T>) {
  return (
    <StyledInputWrapper>
      <FormLabel>{lang?.signUpPage.form.password.label}</FormLabel>
      <Gap $height={0.5} />
      <StyledInput
        {...register(name, {
          required: true,
          pattern: {
            value: formConfig.password.regex,
            message: lang.inputs.passwordPattern,
          },
          validate: validate,
        })}
        type="password"
        placeholder={lang.signUpPage.form.password.placeholder}
      />
    </StyledInputWrapper>
  );
}
